import React, {useEffect, useMemo, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
import PatientIPSearch from "../PatientIPSearch";
function LaundryManagement() {
    const [tab, setTab] = useState("transaction");
    const [linen, setLinen] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [processes, setProcesses] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [patient, setPatient] = useState({});
    const [linenData, setLinenData] = useState([]);
    const [transaction, setTransaction] = useState({
        linen_code: "",
        linen_name: "",
        transaction_type: "ISSUE",
        department: "",
        ip_id: "",
        pat_id: "",
        patient_name: "",
        quantity: "",
        condition: "GOOD",
        received_by: "",
        issued_by: userName || "",
        remarks: ""
    });
    const [process, setProcess] = useState({
        linen_code: "",
        quantity: "",
        wash_type: "NORMAL",
        machine_no: "",
        temperature: "",
        chemical_used: "",
        result: "PROCESSING",
        operator: userName || "",
        remarks: ""
    });
    const [linenForm, setLinenForm] = useState({
        linen_code: "",
        linen_name: "",
        linen_type: "",
        department: "",
        total_quantity: "",
        clean_quantity: "",
        dirty_quantity: "",
        reorder_level: ""
    });
    useEffect(() => {
        loadData();
    }, []);
    const loadData = () => {
        axios.get(`${baseUrl}add-dept/`).then(r => setDepartments(r.data || []));
        axios.get(`${baseUrl}laundry/linen/`).then(r => setLinen(r.data || []));
        axios.get(`${baseUrl}laundry/transactions/`).then(r => setTransactions(r.data || []));
        axios.get(`${baseUrl}laundry/process/`).then(r => setProcesses(r.data || []));
    };
    const loadLinenData = () => {
        axios
            .get(`${baseUrl}laundry/linen/`)
            .then(response => {
                setLinenData(
                    Array.isArray(response.data)
                        ? response.data
                        : response.data.results || []
                );
            })
            .catch(error => {
                console.log("Linen load error:", error);
            });
    };
    useEffect(() => {
        loadLinenData();
    }, []);
    const departmentOptions = useMemo(() => {
        return departments
            .filter(item => item.department)
            .map(item => item.department);
    }, [departments]);
    const handleSetChange = (e) => {
        setTransaction(prev => ({
            ...prev, [e.target.name]: e.target.value
        }));
    };
    const selectPatient = data => {
        setPatient(data);
        const patientDepartment = data?.department || data?.dept || data?.department_name || "";
        setTransaction(prev => ({
            ...prev,
            ip_id: data.ip_id || "",
            pat_id: data.pat_id || "",
            patient_name: data?.patient_name || data?.patient || data?.pat?.patient || "",
            department: patientDepartment
        }));
    };
    const selectLinen = e => {
        const item = linen.find(x => x.linen_code === e.target.value);
        setTransaction({
            ...transaction, linen_code: item?.linen_code || "", linen_name: item?.linen_name || ""
        });
    };
    const submitTransaction = () => {
        const fd = new FormData();
        fd.append("transaction_no", "LIN-" + Date.now());
        Object.keys(transaction).forEach(key => {
            fd.append(key, transaction[key]);
        });
        fd.append("addedby", userName);
        fd.append("ip_add", ipAddress);
        fd.append("location", userLocation);
        axios.post(`${baseUrl}laundry/transactions/`, fd)
            .then(() => {
                Swal.fire("Success", "Laundry transaction saved", "success");
                loadData();
            })
            .catch(error => {
                console.log(error);
                Swal.fire("Error", "Unable to save transaction", "error");
            });
    };
    const submitProcess = () => {
        const fd = new FormData();
        fd.append("process_no", "WASH-" + Date.now());
        Object.keys(process).forEach(key => {
            fd.append(key, process[key]);
        });
        axios.post(`${baseUrl}laundry/process/`, fd)
            .then(() => {
                Swal.fire("Success", "Laundry process created", "success");
                loadData();
            });
    };
    const submitLinen = () => {
        const fd = new FormData();
        Object.keys(linenForm).forEach(key => {
            fd.append(key, linenForm[key]);
        });
        fd.append("status", "ACTIVE");
        fd.append("addedby", userName);
        axios.post(`${baseUrl}laundry/linen/`, fd)
            .then(() => {
                Swal.fire("Success", "Linen master created", "success");
                loadData();
            });
    };
    return (<section className="container-fluid mt-4">

        <h3 className="text-center bg-info text-white p-2">

            <i className="fa fa-shirt"></i>
            {" "}Laundry Management

        </h3>

        <div className="btn-group mb-3">

            <button
                className="btn btn-primary"
                onClick={() => setTab("transaction")}
            >
                Issue / Return
            </button>

            <button
                className="btn btn-success"
                onClick={() => setTab("process")}
            >
                Washing Process
            </button>

            <button
                className="btn btn-secondary"
                onClick={() => setTab("master")}
            >
                Linen Master
            </button>

            <button
                className="btn btn-info"
                onClick={() => setTab("stock")}
            >
                Linen Stock
            </button>

        </div>

        {tab === "transaction" && (<>

            <PatientIPSearch
                onSelect={selectPatient}
            />

            <div className="card">

                <div className="card-header">
                    Linen Issue / Return
                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3 mb-3">

                            <label>IP ID</label>

                            <input
                                className="form-control"
                                value={transaction.ip_id}
                                readOnly
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Patient ID</label>

                            <input
                                className="form-control"
                                value={transaction.pat_id}
                                readOnly
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Patient</label>

                            <input
                                className="form-control"
                                value={transaction.patient_name}
                                readOnly
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Department</label>
                            <select
                                className="form-control"
                                name="department"
                                value={transaction.department}
                                onChange={handleSetChange}
                            >

                                <option value="">
                                    Select Department
                                </option>

                                {departmentOptions.map(department => (<option
                                    key={department}
                                    value={department}
                                >
                                    {department}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Linen</label>

                            <select
                                className="form-control"
                                value={transaction.linen_code}
                                onChange={selectLinen}
                            >

                                <option value="">
                                    Select Linen
                                </option>

                                {linen.map(item => (<option
                                    key={item.id}
                                    value={item.linen_code}
                                >
                                    {item.linen_code}
                                    {" - "}
                                    {item.linen_name}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Transaction</label>

                            <select
                                className="form-control"
                                value={transaction.transaction_type}
                                onChange={e => setTransaction({
                                    ...transaction, transaction_type: e.target.value
                                })}
                            >

                                <option>ISSUE</option>
                                <option>RETURN</option>
                                <option>DIRTY</option>
                                <option>DAMAGE</option>
                                <option>LOST</option>

                            </select>

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Quantity</label>

                            <input
                                type="number"
                                className="form-control"
                                value={transaction.quantity}
                                onChange={e => setTransaction({
                                    ...transaction, quantity: e.target.value
                                })}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Condition</label>

                            <select
                                className="form-control"
                                value={transaction.condition}
                                onChange={e => setTransaction({
                                    ...transaction, condition: e.target.value
                                })}
                            >

                                <option>GOOD</option>
                                <option>DAMAGED</option>
                                <option>STAINED</option>
                                <option>TORN</option>

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Received / Issued By</label>

                            <input
                                className="form-control"
                                value={transaction.received_by}
                                onChange={e => setTransaction({
                                    ...transaction, received_by: e.target.value
                                })}
                            />

                        </div>

                    </div>

                    <button
                        className="btn btn-success"
                        onClick={submitTransaction}
                    >
                        Save Transaction
                    </button>

                </div>

            </div>

            <DataGrid
                className="mt-4"
                rows={transactions}
                columns={[{
                    field: "transaction_no", headerName: "Transaction", width: 150
                }, {
                    field: "linen_name", headerName: "Linen", width: 180
                }, {
                    field: "transaction_type", headerName: "Type", width: 120
                }, {
                    field: "ip_id", headerName: "IP ID", width: 120
                }, {
                    field: "pat_id", headerName: "Patient ID", width: 130
                }, {
                    field: "patient_name", headerName: "Patient", width: 180
                }, {
                    field: "department", headerName: "Department", width: 150
                }, {
                    field: "quantity", headerName: "Qty", width: 80
                }, {
                    field: "condition", headerName: "Condition", width: 120
                }]}
                autoHeight
                slots={{
                    toolbar: GridToolbar
                }}
            />

        </>)}

        {tab === "process" && (<div className="card">

            <div className="card-header">
                Laundry Washing Process
            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-3 mb-3">

                        <label>Linen</label>

                        <select
                            className="form-control"
                            value={process.linen_code}
                            onChange={e => setProcess({
                                ...process, linen_code: e.target.value
                            })}
                        >

                            <option value="">
                                Select Linen
                            </option>

                            {linen.map(item => (<option
                                key={item.id}
                                value={item.linen_code}
                            >
                                {item.linen_name}
                            </option>))}

                        </select>

                    </div>

                    <div className="col-md-2 mb-3">

                        <label>Quantity</label>

                        <input
                            type="number"
                            className="form-control"
                            value={process.quantity}
                            onChange={e => setProcess({
                                ...process, quantity: e.target.value
                            })}
                        />

                    </div>

                    <div className="col-md-2 mb-3">

                        <label>Wash Type</label>

                        <select
                            className="form-control"
                            value={process.wash_type}
                            onChange={e => setProcess({
                                ...process, wash_type: e.target.value
                            })}
                        >

                            <option>NORMAL</option>
                            <option>DISINFECTION</option>
                            <option>HIGH TEMPERATURE</option>
                            <option>DELICATE</option>

                        </select>

                    </div>

                    <div className="col-md-2 mb-3">

                        <label>Machine</label>

                        <input
                            className="form-control"
                            value={process.machine_no}
                            onChange={e => setProcess({
                                ...process, machine_no: e.target.value
                            })}
                        />

                    </div>

                    <div className="col-md-2 mb-3">

                        <label>Temperature</label>

                        <input
                            type="number"
                            className="form-control"
                            value={process.temperature}
                            onChange={e => setProcess({
                                ...process, temperature: e.target.value
                            })}
                        />

                    </div>

                </div>

                <button
                    className="btn btn-primary"
                    onClick={submitProcess}
                >
                    Start Laundry Process
                </button>

            </div>

            <DataGrid
                className="mt-4"
                rows={processes}
                columns={[{
                    field: "process_no", headerName: "Process No", width: 160
                }, {
                    field: "linen_code", headerName: "Linen", width: 160
                }, {
                    field: "quantity", headerName: "Quantity", width: 100
                }, {
                    field: "wash_type", headerName: "Wash Type", width: 160
                }, {
                    field: "machine_no", headerName: "Machine", width: 130
                }, {
                    field: "result", headerName: "Result", width: 120
                }]}
                autoHeight
                slots={{
                    toolbar: GridToolbar
                }}
            />

        </div>)}

        {tab === "master" && (<div className="card">

            <div className="card-header">
                Linen Master
            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-3 mb-3">

                        <label>
                            Linen Code
                        </label>

                        <input
                            className="form-control"
                            value={linenForm.linen_code}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                linen_code: e.target.value
                            })}
                        />

                    </div>


                    <div className="col-md-3 mb-3">

                        <label>
                            Linen Name
                        </label>

                        <input
                            className="form-control"
                            value={linenForm.linen_name}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                linen_name: e.target.value
                            })}
                        />

                    </div>


                    {/* =====================================================
        LINEN TYPE
    ===================================================== */}

                    <div className="col-md-3 mb-3">

                        <label>
                            Linen Type
                        </label>

                        <select
                            className="form-control"
                            name="linen_type"
                            value={linenForm.linen_type}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                linen_type: e.target.value
                            })}
                        >

                            <option value="">
                                Select Linen Type
                            </option>

                            <option value="BED SHEET">
                                Bed Sheet
                            </option>

                            <option value="PILLOW COVER">
                                Pillow Cover
                            </option>

                            <option value="BLANKET">
                                Blanket
                            </option>

                            <option value="PATIENT GOWN">
                                Patient Gown
                            </option>

                            <option value="SURGICAL GOWN">
                                Surgical Gown
                            </option>

                            <option value="SCRUB">
                                Scrub
                            </option>

                            <option value="CURTAIN">
                                Curtain
                            </option>

                            <option value="TOWEL">
                                Towel
                            </option>

                            <option value="OTHER">
                                Other
                            </option>

                        </select>

                    </div>


                    {/* =====================================================
        DEPARTMENT
    ===================================================== */}

                    <div className="col-md-3 mb-3">

                        <label>
                            Department
                        </label>

                        <select
                            className="form-control"
                            name="department"
                            value={linenForm.department}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                department: e.target.value
                            })}
                        >

                            <option value="">
                                Select Department
                            </option>

                            {departmentOptions.map(department => (
                                <option
                                    key={department}
                                    value={department}
                                >
                                    {department}
                                </option>
                            ))}

                        </select>

                    </div>


                    <div className="col-md-3 mb-3">

                        <label>
                            Total Quantity
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={linenForm.total_quantity}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                total_quantity: e.target.value
                            })}
                        />

                    </div>


                    <div className="col-md-3 mb-3">

                        <label>
                            Clean Quantity
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={linenForm.clean_quantity}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                clean_quantity: e.target.value
                            })}
                        />

                    </div>


                    <div className="col-md-3 mb-3">

                        <label>
                            Dirty Quantity
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={linenForm.dirty_quantity}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                dirty_quantity: e.target.value
                            })}
                        />

                    </div>


                    <div className="col-md-3 mb-3">

                        <label>
                            Reorder Level
                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={linenForm.reorder_level}
                            onChange={e => setLinenForm({
                                ...linenForm,
                                reorder_level: e.target.value
                            })}
                        />

                    </div>

                </div>
                <button
                    className="btn btn-success"
                    onClick={submitLinen}
                >
                    Add Linen
                </button>

            </div>
            <DataGrid
                rows={linenData}
                columns={[
                    {
                        field: "id",
                        headerName: "ID",
                        width: 80
                    },
                    {
                        field: "linen_code",
                        headerName: "Linen Code",
                        width: 150
                    },
                    {
                        field: "linen_name",
                        headerName: "Linen Name",
                        width: 220
                    },
                    {
                        field: "linen_type",
                        headerName: "Linen Type",
                        width: 160
                    },
                    {
                        field: "department",
                        headerName: "Department",
                        width: 180
                    },
                    {
                        field: "total_quantity",
                        headerName: "Total Qty",
                        width: 120,
                        type: "number"
                    },
                    {
                        field: "clean_quantity",
                        headerName: "Clean Qty",
                        width: 120,
                        type: "number"
                    },
                    {
                        field: "dirty_quantity",
                        headerName: "Dirty Qty",
                        width: 120,
                        type: "number"
                    },
                    {
                        field: "reorder_level",
                        headerName: "Reorder Level",
                        width: 130,
                        type: "number"
                    },
                    {
                        field: "status",
                        headerName: "Status",
                        width: 120
                    }
                ]}
                getRowId={(row) => row.id}
                autoHeight
                slots={{
                    toolbar: GridToolbar
                }}
                pageSizeOptions={[10, 25, 50, 100]}
            />
        </div>)}

        {tab === "stock" && (<DataGrid
            rows={linen}
            columns={[{
                field: "linen_code", headerName: "Code", width: 140
            }, {
                field: "linen_name", headerName: "Linen", width: 200
            }, {
                field: "linen_type", headerName: "Type", width: 150
            }, {
                field: "total_quantity", headerName: "Total", width: 100
            }, {
                field: "clean_quantity", headerName: "Clean", width: 100
            }, {
                field: "dirty_quantity", headerName: "Dirty", width: 100
            }, {
                field: "damaged_quantity", headerName: "Damaged", width: 100
            }, {
                field: "lost_quantity", headerName: "Lost", width: 100
            }]}
            autoHeight
            slots={{
                toolbar: GridToolbar
            }}
        />)}

    </section>);
}
export default LaundryManagement;